module.exports = __webpack_public_path__ + "img/mood3.604260c5.png";